const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
// @ constants
const { DECLARATION_RESULT_TO_GIVE_BACK } = require('constants/index');
// @ utilities
const { formatText } = require('core/i18n').i18n;
const { getCurrencySymbol, formatAmount } = require('utilities/currencyHelper');

class PaymentWithDraftSuccessStep extends React.Component {
    render() {
        const { immTaxAndRentsPaymentWithDraft, immAccounts } = this.props;
        const goBackButtonLabel = formatText('paymentWithDraft-backToPG').toUpperCase();
        const backToPG = `/myprofile/`;
        const goBackButton = {
            label: goBackButtonLabel,
            url: backToPG
        }
        const immStepOne = immTaxAndRentsPaymentWithDraft.getIn(['steps', 0]);
        const currencySymbol = getCurrencySymbol(immAccounts.getIn(['balance', 0]));
        const title = formatText('paymentWithDraft-successTitleRetrieval');
        let body, fractionString;

        if (immStepOne.get('declarationResult') === DECLARATION_RESULT_TO_GIVE_BACK) {
            body = formatText('paymentWithDraft-successBodyRetrieval', [
                immStepOne.get('justificative'),
                formatAmount(immStepOne.get('amountToReturn')),
                currencySymbol
            ]);
        } else {
            if (immStepOne.get('fractionPayment')) {

                if (immStepOne.get('domiciliateSecondPayment')) {
                    fractionString = formatText('paymentWithDraft-successBodyPaymentFractionDomicilate', [
                        formatAmount(immStepOne.get('firstPayment')),
                        currencySymbol
                    ]);
                } else {
                    fractionString = formatText('paymentWithDraft-successBodyPaymentFraction', [
                        formatAmount(immStepOne.get('firstPayment')),
                        currencySymbol
                    ]);
                }

            } else {
                fractionString = formatText('paymentWithDraft-successBodyPaymentWithoutFraction');
            }

            body = formatText('paymentWithDraft-successBodyPayment', [
                immStepOne.get('justificative'),
                formatAmount(immStepOne.get('differentialFee')),
                currencySymbol,
                fractionString
            ]);
        }

        return (
            <article className="payment-with-draft-success row no-gutter">
                <div className="col-xs-offset-2 col-xs-8">
                    <WizardSuccess
                        successMessage={title}
                        mainButton={goBackButton}
                    >
                        <section className="row no-gutter">
                            <div className="col-xs-12">
                                {body}
                            </div>
                        </section>
                    </WizardSuccess>
                </div>
            </article>
        )
    }
}

PaymentWithDraftSuccessStep.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immTaxAndRentsPaymentWithDraft: PropTypes.object.isRequired
};

module.exports = PaymentWithDraftSuccessStep;